<template>
	<div class="cour">
		<div>
			<div class="tit">
				<el-row>
					<el-col :span="19">
						<div class="grid-blue">考试记录</div>
					</el-col>
					<el-col :span="5">
						<!-- <div class="grid-red"><i class="el-icon-warning"></i>温馨提示: 完成所有学时方可进入考试</div> -->
					</el-col>
				</el-row>
			</div>
			<div class="list" v-if="examlist.length!=0">
				<div class="list-item" v-for="(item,index) in examlist" :key="index">
					<el-row>
						<el-col :span="12">
							<div class="list-itemimg"><img :src="item.full_cover_image" /></div>
						</el-col>
						<el-col :span="12">
							<div class="list-itemtit">{{item.title}}</div>
							<div class="list-itembut">
								<el-tag type="success" v-if="item.grade >=item.num" effect="dark">已通过
								</el-tag>
								<el-tag type="warning" v-else effect="dark">未通过</el-tag>
							</div>
						</el-col>
					</el-row>
					<el-row style="margin-top: 8px;">
						<el-col :span="10">
							<div class="items">
								<div><img src="../../assets/exam/1.svg" alt=""></div>
								<div>考试时间：{{$formatTimeStamp(item.createtime) }}</div>
							</div>

						</el-col>
						<el-col :span="7">
							<div class="items">
								<div><img src="../../assets/exam/test.svg" alt=""></div>
								<div>及格线：{{item.num}}分</div>
							</div>
						</el-col>
						<el-col :span="7">
							<div class="items">
								<div><img src="../../assets/exam/4.svg" alt=""></div>
								<div>答对题数：{{item.correct}}道</div>
							</div>
						</el-col>
					</el-row>
					<el-row>
						<el-col :span="10">
							<div class="items">
								<div><img src="../../assets/exam/record.svg" alt=""></div>
								<div>考试用时：{{item.time}}分钟</div>
							</div>

						</el-col>
						<el-col :span="7">
							<div class="items">
								<div><img src="../../assets/exam/4.svg" alt=""></div>
								<div>答错题数：{{item.mistake}}道</div>
							</div>
						</el-col>
						<el-col :span="7">
							<div class="items">
								<div><img src="../../assets/exam/5.svg" alt=""></div>
								<div>考试得分：{{item.grade}}分</div>
							</div>
						</el-col>
					</el-row>
				</div>
			</div>
			<Nodata v-else></Nodata>
		</div>

	</div>
</template>

<script>
	import Nodata from '@/components/Nodata.vue'
	export default {
		components: {
			Nodata
		},
		data() {
			return {
				examlist: []
			};
		},
		created() {
			this.getexamlist()
		},
		methods: {
			//获取我的考试列表
			getexamlist() {
				this.$http({
						method: 'GET',
						url: '/Exam/examlist',
						headers: {
							requireAuth: true // 这里通过设置requireAuth为true来启用token检查
						},
					})
					.then(response => {
						if (response.code == 1) {
							this.examlist = response.data.data

						} else {
							this.$message(response.msg);
						}

					})
					.catch(error => {
						console.log(error)
					})
			},
			exam(item) {
				this.$router.push({
					path: "/Exam",
					query: {
						course_id: item.edu_course_id,
						title: item.title
					}

				})
			},
			handleClick(tab, event) {
				console.log(tab, event);
			}
		}
	};
</script>

<style scoped>
	/deep/.el-tabs__item {
		font-size: 16px !important;
	}

	.el-button--medium.is-round {
		padding: 8px 20px !important;
	}

	ul {
		margin: 0 !important;
		padding: 0 !important;
	}

	.cour {
		width: 100%;
		overflow: hidden;
		/* height: calc(100vh - 333px); */
		min-height: calc(100vh - 333px);
		background: #FFFFFF;
		border: 1px solid rgba(0, 0, 0, 0.07);
		padding-bottom: 10px;
	}

	.cour .tit {
		width: 100%;
		height: 45px;
		line-height: 45px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
		border-radius: 0px 0px 5px 5px;
	}

	.grid-blue {
		font-size: 18px;
		color: #1072DA;
		padding-left: 20px;
	}

	.grid-red {
		font-size: 16px;
		color: #FF0000;
	}

	.list {
		/* overflow-y: auto;
		height: calc(100vh - 388px); */
	}

	/* 滚动条整体 */
	.list::-webkit-scrollbar {
		height: 20px;
		width: 1px;
	}

	/* 两个滚动条交接处 -- x轴和y轴 */
	.list::-webkit-scrollbar-corner {
		background-color: transparent;
	}

	/* 滚动条滑块 */
	.list::-webkit-scrollbar-thumb {
		border-radius: 10px;
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		background: #535353;
	}

	/* 滚动条轨道 */
	.list::-webkit-scrollbar-track {
		-webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
		border-radius: 10px;
		background: #ededed;
	}

	.list-item {
		width: 448px;
		height: 192px;
		background: #FFFFFF;
		box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.5);
		float: left;
		border-radius: 5px;
		margin: 14px 0 0 13px;
		overflow-x: hidden;

	}

	.list-itemimg {
		width: 221px;
		height: 113px;
		margin: 10px 0 0 7px;
		overflow: hidden;
		border-radius: 5px;
	}

	.list-itemimg img {
		width: 221px;
		height: 113px;
		border-radius: 5px;
		cursor: pointer;
		transition: all 0.6s;
	}

	.list-item:hover .list-itemimg img {
		transform: scale(1.4);
	}

	.list-itemtit {
		padding: 10px 10px 0 20px;
		height: 58px;
		font-family: PingFangSC, PingFang SC;
		font-weight: 400;
		font-size: 16px;
		color: #000000;
		line-height: 22px;
	}

	.list-itembut {
		margin: 20px 0 0 132px;
	}

	.list-itembut .el-tag {
		width: 70px;
		height: 30px;
		line-height: 30px;
		font-size: 14px;
		color: #FFFFFF;
		text-align: center;
		padding: 0;
	}

	.items {
		width: 250px;
		margin-top: 7px;
		font-size: 12px;
	}

	.items div:nth-child(1) {
		width: 16px;
		height: 16px;
		float: left;
		margin-left: 8px;
	}

	.items div:nth-child(1) img {
		width: 16px;
		height: 16px;

	}

	.items div:nth-child(2) {
		float: left;
		margin-left: 4px;
		color: #7D7D7D;
	}
</style>
